import { cloudinaryVideo } from '../config/cloudinaryVideos';

const videoCardOne = cloudinaryVideo('8084751-uhd_3840_2160_25fps', 'card');
const videoCardTwo = cloudinaryVideo('7687810-uhd_4096_2160_24fps', 'card');
const videoDetailThree = cloudinaryVideo('8501993-uhd_2160_3840_25fps', 'card');
const videoDetailFour = cloudinaryVideo('6153453-uhd_4096_2160_25fps', 'card');
const videoDetailFive = cloudinaryVideo('8467244-uhd_3840_2160_25fps', 'card');
const videoPoolSix = cloudinaryVideo('4354448-uhd_3840_2160_25fps', 'card');
const videoPoolSeven = cloudinaryVideo('8328106-uhd_2160_3840_25fps', 'card');
const videoPoolEight = cloudinaryVideo('8501993-uhd_2160_3840_25fps', 'card');
const videoPoolNine = cloudinaryVideo('7688618-uhd_2160_4096_24fps', 'card');
const videoPoolTen = cloudinaryVideo('8084494-uhd_3840_2160_25fps', 'card');
const videoPoolEleven = cloudinaryVideo('8084620-uhd_3840_2160_25fps', 'card');
const videoPoolTwelve = cloudinaryVideo('8464662-uhd_3840_2160_25fps', 'card');
const videoPoolThirteen = cloudinaryVideo('8327799-uhd_3840_2160_25fps', 'card');
const videoPoolFourteen = cloudinaryVideo('8467244-uhd_3840_2160_25fps', 'card');
const videoPoolFifteen = cloudinaryVideo('8086703-uhd_3840_2160_25fps', 'card');
const videoPoolSixteen = cloudinaryVideo('8084494-uhd_3840_2160_25fps', 'card');

export let BLOG_VIDEO_POOL = [
  videoCardOne,
  videoCardTwo,
  videoDetailThree,
  videoDetailFour,
  videoDetailFive,
  videoPoolSix,
  videoPoolSeven,
  videoPoolEight,
  videoPoolNine,
  videoPoolTen,
  videoPoolEleven,
  videoPoolTwelve,
  videoPoolThirteen,
  videoPoolFourteen,
  videoPoolFifteen,
  videoPoolSixteen,
];

export function hydrateBlogVideos(pool) {
  if (Array.isArray(pool)) {
    BLOG_VIDEO_POOL = pool;
  }
}

export const getBlogVideoPoolLength = () => BLOG_VIDEO_POOL.length;

export {
  videoCardOne,
  videoCardTwo,
  videoDetailThree,
  videoDetailFour,
  videoDetailFive,
  videoPoolSix,
  videoPoolSeven,
  videoPoolEight,
  videoPoolNine,
  videoPoolTen,
  videoPoolEleven,
  videoPoolTwelve,
  videoPoolThirteen,
  videoPoolFourteen,
  videoPoolFifteen,
  videoPoolSixteen,
};
